'use client'

import { Builder, withChildren } from '@builder.io/react'

import { ExpertGrid } from './ExpertGrid'
import { expertGridDefaults } from './ExpertGrid.defaults'
import { ChildrenPositions } from './ExpertGrid.props'

Builder.registerComponent(withChildren(ExpertGrid), {
  name: 'ExpertGrid',
  inputs: [
    {
      name: 'children',
      type: 'uiBlocks',
      defaultValue: expertGridDefaults.children,
    },
    {
      name: 'childrenPositionDesktop',
      friendlyName: 'Child component position on desktop',
      type: 'text',
      enum: ChildrenPositions as any,
      showIf: (properties) => !!properties.get('children'),
      defaultValue: expertGridDefaults.childrenPositionDesktop,
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: expertGridDefaults.backgroundColor,
    },
    {
      name: 'heading',
      type: 'html',
      defaultValue: expertGridDefaults.heading,
    },
    {
      name: 'subheading',
      type: 'html',
      defaultValue: expertGridDefaults.subheading,
    },
    {
      name: 'imageSrcDesktop',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: expertGridDefaults.imageSrcDesktop,
    },
    {
      name: 'imageScaleDesktop',
      type: 'number',
      defaultValue: expertGridDefaults.imageScaleDesktop,
    },
    {
      name: 'imageRightDesktop',
      type: 'number',
      defaultValue: expertGridDefaults.imageRightDesktop,
    },
    {
      name: 'imageSrcMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
      defaultValue: expertGridDefaults.imageSrcMobile,
    },
    {
      name: 'imageAlt',
      type: 'string',
      defaultValue: expertGridDefaults.imageAlt,
    },
    {
      name: 'experts',
      type: 'list',
      subFields: [
        {
          name: 'imageSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'svg'],
        },
        {
          name: 'name',
          type: 'html',
        },
        {
          name: 'description',
          type: 'html',
        },
        {
          name: 'imageAlt',
          type: 'string',
        },
      ],
      defaultValue: expertGridDefaults.experts,
    },
    {
      name: 'columnsDesktop',
      type: 'number',
      defaultValue: expertGridDefaults.columnsDesktop,
    },
    {
      name: 'columnsMobile',
      type: 'number',
      defaultValue: expertGridDefaults.columnsMobile,
    },
  ],
})
